module.exports = __webpack_public_path__ + "static/media/header_start.62aecfd0.jpg";